/**
 * Scheduling limits for the messaging system
 * These constants define the daily limits for scheduled messages
 */

/**
 * Maximum number of messages a user can schedule per day
 * This is a per-user limit that resets daily
 */
export const MAX_SCHEDULED_MESSAGES_PER_DAY = 25;

/**
 * Maximum number of scheduled messages that can be sent per day per user
 * This is a per-user limit that resets daily
 * Note: Manual messages are unlimited
 */
export const MAX_SCHEDULED_MESSAGES_SENT_PER_DAY = 10;
